var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstacureLightLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "InstaCured_Logo_Final_Patients") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.53,192.41a.4.4,0,0,1-.64-.3v-115a7.73,7.73,0,0,1,.3-2.39,6.33,6.33,0,0,1,5.87-4.33H312.91a7.89,7.89,0,0,1,2.27.27,6.29,6.29,0,0,1,4.53,5.91v.66q0,43.44,0,86.87a8,8,0,0,1-.23,2.18,6.33,6.33,0,0,1-5.94,4.63c-.34,0-.69,0-1,0H222.07a2.57,2.57,0,0,0-1.74.61Q207,182,193.53,192.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.72,194a.4.4,0,0,1,.31-.64H436.09a8,8,0,0,1,2.42.3,6.31,6.31,0,0,1,4.37,5.81c0,.2,0,.4,0,.59q0,56.1,0,112.19a7.8,7.8,0,0,1-.28,2.25,6.34,6.34,0,0,1-6,4.49H348.29a8.18,8.18,0,0,1-2.21-.22,6.31,6.31,0,0,1-4.68-5.88c0-.35,0-.69,0-1q0-44.8,0-89.59a2.58,2.58,0,0,0-.62-1.72Q330.25,207.27,319.72,194Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.53,319.59a.4.4,0,0,1,.64.3v115a7.45,7.45,0,0,1-.31,2.39,6.31,6.31,0,0,1-5.86,4.33H200.15a7.89,7.89,0,0,1-2.27-.27,6.27,6.27,0,0,1-4.53-5.91c0-.22,0-.44,0-.66V347.88a8.46,8.46,0,0,1,.22-2.18,6.35,6.35,0,0,1,5.95-4.63c.34,0,.69,0,1,0H291a2.53,2.53,0,0,0,1.73-.61q13.39-10.45,26.81-20.87Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.28,318.41a.39.39,0,0,1-.31.63H75.91a8,8,0,0,1-2.42-.3,6.31,6.31,0,0,1-4.37-5.81c0-.2,0-.39,0-.59q0-56.1,0-112.19a7.8,7.8,0,0,1,.28-2.25,6.34,6.34,0,0,1,6-4.49h88.36a8.18,8.18,0,0,1,2.21.22,6.31,6.31,0,0,1,4.68,5.88c0,.35,0,.69,0,1q0,44.79,0,89.58a2.55,2.55,0,0,0,.62,1.72q10.54,13.27,21.07,26.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstacureLightLogo);
export default __webpack_public_path__ + "static/media/InstacureLightLogo.173f7d6d.svg";
export { ForwardRef as ReactComponent };